import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetFeedV2Request } from './get-feed-v2-request';
import type { IGetFeedV2Response } from './get-feed-v2-response';
import { getFeedV2ResponseSchema } from './get-feed-v2-response';

export async function getFeedV2Api(
  params?: IGetFeedV2Request,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetFeedV2Response>> {
  return getRequest<IGetFeedV2Response>({
    path: '/feed/v2',
    schema: getFeedV2ResponseSchema,
    options: {
      ...options,
      params: params?.cursor ? { cursor: params.cursor } : undefined,
    },
  });
}
